export const environment = {
  production: false,
  envName: 'development',
  // apiBaseUrl: 'http://ec2-65-2-132-57.ap-south-1.compute.amazonaws.com:603',
  apiBaseUrl: 'https://ipzxtewhadwa005.azurewebsites.net',
  forgeryApiBaseUrl: 'https://ipzxtewhadwa018.azurewebsites.net',
  // Deployed dev build always goes through the real Azure AD redirect.
  ssoBypass: {
    enabled: false,
    email: 'subhajit.d.debnath@pwc.com',
  },
  SSO: {
    loginURL: 'https://login.microsoftonline.com/513294a0-3e20-41b2-a970-6d30bf1546fa/oauth2/v2.0/authorize',
    response_type: 'code',
    client_id: '7d7e056e-6e12-4f03-b820-ce5c002af805',
    redirect_uri: 'https://anomalydetectionplatform.pwc.in/assets/layout/ssohtml/sso.html',
    scope: 'openid profile email api://cb5f0907-3004-4818-a030-cc9cd128ce2e/readaccess',
    grant_type: 'authorization_code',
    access_token: 'https://login.microsoftonline.com/513294a0-3e20-41b2-a970-6d30bf1546fa/oauth2/v2.0/token',
    user_info: 'https://graph.microsoft.com/v1.0/users/',
  }
};
